module.exports = __webpack_public_path__ + "img/syukyaku-kyoutu-logo002.ef0ebb30.png";